import React from 'react';
import { Link } from 'react-router-dom';
import About1 from '../../images/Carpentry-work2.jpg';
import { Helmet } from 'react-helmet';

const Carpentryworks = (props) => {

      const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    
    return (
        

         <>
      <Helmet>
        <title>Carpentry Works</title>
        <meta name="description" content="Custom Carpentry Tailored to Your Space" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">

                 

                    <div className="col-lg-6 col-12">
                        <div className="about-right">
                            <div className="text">
                                <span>About</span>
                                <h1>Carpentry Works</h1>
                                <h6>Custom Carpentry Tailored to Your Space</h6>
                                <p>
                            Our in-house carpentry team crafts made-to-measure
                             furniture and fixtures that blend aesthetics with usability.
                                </p>
                                <h4>We undertake :</h4>
                                <ul>
                                    <li>Modular kitchen carpentry</li>
                                    <li>Wardrobes, TV units, shelves</li>
                                    <li>Custom furniture (beds, tables, cabinets)</li>
                                    <li>Wooden partitions & ceiling panels</li>
                                    <li>Door & window framing</li>
                                    <p>Top-quality wood, superior finish, and lasting craftsmanship — all under one roof.</p>
                                </ul>
                              <a href='tel:9663222146' className='theme-btn'>Call Us: +91 96632 22146</a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 col-12">
                        <div className="about-left">
                            <img src={About1} alt="" />
                            
                        </div>
                    </div>


                   
                    
                
                </div>
            </div>
        </section>
    </>
    )
}

export default Carpentryworks ;